module.exports = __webpack_public_path__ + "static/media/ai-banner-avatar-3.b2fde478.webp";